import React from 'react'
import '../../styles/Expertise/Expertise2D.css'
import { Fade } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import AccordionText from '../Utils/AccordionText'
import expertise2DSection1 from '../../assets/expertise/expertise-plan-2D-section1.jpg'
import expertise2DSection2 from '../../assets/expertise/expertise-plan-2D-section2.jpg'
import expertise2DSection4 from '../../assets/expertise/expertise-plan-2D-section4.jpg'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function Expertise2D() {

    const section2AccordionData = [
        {
            title: "Conception et rénovation :",
            text: "Que ce soit pour des travaux de rénovation, d’aménagement intérieur ou pour l’extension d’une propriété, les plans cotés offrent une base solide pour l’élaboration des projets, garantissant que chaque modification est planifiée avec précision."
        }, {
            title: "Transactions immobilières : ",
            text: "Pour la vente ou la location, ces plans ajoutent une valeur considérable à la présentation d’un bien, permettant aux potentiels acquéreurs ou locataires de saisir immédiatement les dimensions et l’organisation des espaces."
        }, {
            title: "Gestion de copropriété :",
            text: "Lors de la mise en copropriété d’un immeuble, ils facilitent l’établissement de l’état descriptif de division et la répartition des quotes-parts (tantièmes ou millièmes) entre les différents lots."
        }
    ]

    const section4AccordionData = [
        {
            title: "Précision et fiabilité :",
            text: "Nos mesures précises et nos représentations fidèles garantissent des plans sur lesquels vous pouvez compter pour vos projets."
        }, {
            title: "Conseil expert :",
            text: "Notre équipe vous guide et vous conseille, optimisant l’utilisation de vos espaces selon vos besoins et objectifs."
        }, {
            title: "Solutions sur mesure :",
            text: "Nous adaptons nos services à chaque projet, assurant une réponse personnalisée à vos demandes."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Plans cotés 2D - E5M Diagnostics" />
                <meta name="description" content="Plans cotés 2D sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Plans cotés 2D - E5M Diagnostics" />
                <meta property="og:description" content="Plans cotés 2D sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/plans-cotés-2D" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/plans-cotés-2D" />
            </Helmet>

            <BrowserView>
                <div id='expertise2D'>
                    <div id='header'>
                        <div id='expertise2DHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Plans cotés</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='expertise2DSection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertise2DSection1Left'>
                                    <div className='sectionText'>
                                        Les plans cotés représentent un élément fondamental dans le domaine de l’immobilier et de la construction, fournissant une représentation graphique détaillée et précise d’un bâtiment ou d’un espace. Ces plans, enrichis de
                                        mesures spécifiques (longueurs, largeurs, hauteurs) et d’une échelle de référence, sont indispensables à la planification et à la réalisation de projets variés. Grâce à leur précision, ils permettent de visualiser et de
                                        comprendre l’agencement spatial, facilitant ainsi la conception, la rénovation, ou l’optimisation d’un bien immobilier.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='expertise2DSection1Right'>
                                    <img src={expertise2DSection1} id='expertise2DSection1Image' alt='expertise-2d-section1' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertise2DSection2'>
                        <Col sm={6}>
                            <div id='expertise2DSection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={expertise2DSection2} id='expertise2DSection2Image' alt='expertise-2d-section2' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='expertise2DSection2Right'>
                                    <h1 className='sectionTitle'>Utilité des plans cotés</h1>
                                    <div id='expertise2DSection2Accordion'>
                                        <div className='sectionAccordion'>
                                            <Accordion>
                                                {section2AccordionData.map((item, index) => {
                                                    return (
                                                        <AccordionText
                                                            key={index}
                                                            indexKey={index}
                                                            header={item.title}
                                                            body={item.text}
                                                        />
                                                    )
                                                })}
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='expertise2DSection3'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>Élaboration des Plans Cotés</h1>
                            <div className='sectionText'>
                                L’élaboration de plans cotés requiert une expertise technique, alliant précision dans le relevé des mesures à une clarté dans la représentation graphique. Ce processus commence par un relevé détaillé de l’existant, où chaque dimension de
                                la structure est soigneusement mesurée. Ces informations sont ensuite transposées en un plan clair, où figurent toutes les cotations nécessaires, l’échelle, ainsi que les spécificités de chaque espace ou élément du bâtiment.
                            </div>
                        </Fade>
                    </div>
                    <Row id='expertise2DSection4'>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='expertise2DSection4Left'>
                                    <h1 className='sectionTitle'>Pourquoi Choisir E5M Diagnostics ?</h1>
                                    <div className='sectionText'>
                                        E5M Diagnostics se distingue par son expertise dans la création de plans cotés pour tout type de projet immobilier. Notre approche minutieuse assure :
                                    </div>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                    <div className='sectionText'>
                                        En somme, les plans cotés sont cruciaux pour une multitude d’aspects liés à l’immobilier et à la construction. En confiant cette tâche à E5M Diagnostics, vous bénéficiez d’une expertise avérée, d’une précision inégalée,
                                        et d’un accompagnement dédié, essentiels à la réussite de votre projet.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='expertise2DSection4Right'>
                                    <img src={expertise2DSection4} id='expertise2DSection4Image' alt='expertise-2d-section4' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </div>
            </BrowserView>

            <MobileView>
                <div id='expertise2D'>
                    <div id='header'>
                        <div id='expertise2DHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Plans cotés</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='expertise2DSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <div className='sectionTextMobile'>
                                Les plans cotés représentent un élément fondamental dans le domaine de l'immobilier et de la construction, fournissant une représentation graphique détaillée et précise d'un bâtiment ou d'un espace. Ces plans, enrichis de
                                mesures spécifiques (longueurs, largeurs, hauteurs) et d'une échelle de référence, sont indispensables à la planification et à la réalisation de projets variés. Grâce à leur précision, ils permettent de visualiser et de
                                comprendre l'agencement spatial, facilitant ainsi la conception, la rénovation, ou l'optimisation d'un bien immobilier.
                            </div>
                            <img src={expertise2DSection1} id='expertise2DSection1ImageMobile' alt='expertise-2d-section1' />
                        </Fade>
                    </div>
                    <div id='expertise2DSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={expertise2DSection2} id='expertise2DSection2ImageMobile' alt='expertise-2d-section2' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Utilité des plans cotés</h1>
                            <div className='sectionAccordion sectionAccordionMobile'>
                                <Accordion>
                                    {section2AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='expertise2DSection3Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Élaboration des Plans Cotés</h1>
                            <div className='sectionTextMobile'>
                                L'élaboration de plans cotés requiert une expertise technique, alliant précision dans le relevé des mesures à une clarté dans la représentation graphique. Ce processus commence par un relevé détaillé de l'existant, où chaque dimension de
                                la structure est soigneusement mesurée. Ces informations sont ensuite transposées en un plan clair, où figurent toutes les cotations nécessaires, l'échelle, ainsi que les spécificités de chaque espace ou élément du bâtiment.
                            </div>
                        </Fade>
                    </div>
                    <div id='expertise2DSection4Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Pourquoi Choisir E5M Diagnostics ?</h1>
                            <div className='sectionTextMobile'>
                                E5M Diagnostics se distingue par son expertise dans la création de plans cotés pour tout type de projet immobilier. Notre approche minutieuse assure :
                            </div>
                            <div className='sectionAccordion sectionAccordionMobile'>
                                <Accordion>
                                    {section4AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                            <div className='sectionTextMobile'>
                                En somme, les plans cotés sont cruciaux pour une multitude d'aspects liés à l'immobilier et à la construction. En confiant cette tâche à E5M Diagnostics, vous bénéficiez d'une expertise avérée, d'une précision inégalée,
                                et d'un accompagnement dédié, essentiels à la réussite de votre projet.
                            </div>
                            <img src={expertise2DSection4} id='expertise2DSection4ImageMobile' alt='expertise-2d-section4' />
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default Expertise2D